import Partners from 'views/Partners/Partners.jsx'
import Discounts from 'views/Discounts/Discounts.jsx'
import DiscountConditions from 'views/Discounts/DiscountConditions.jsx'
import FabricLines from 'views/FabricLines/FabricLines.jsx'
import Fabrics from 'views/Fabrics/Fabrics.jsx'
import Products from 'views/Products/Products.jsx'
import StockProducts from 'views/StockProducts/StockProducts.jsx'
import ProductProfile from 'views/Products/ProductProfile.jsx'
import Orders from 'views/Orders/Orders.jsx'
import OrderDetails from 'views/Orders/OrderDetails.jsx'
import Corporate from 'views/Corporate/Corporate.jsx'
import Banners from 'views/Banners/Banners.jsx'

var eneleRoutes = [
  { path: '/banners', name: 'Banners', icon: 'pe-7s-photo', component: Banners },
  { path: '/partners', name: 'Parceiros', icon: 'pe-7s-loop', component: Partners },
  { path: '/orders', name: 'Pedidos', icon: 'pe-7s-note2', component: Orders },
  { path: '/order/:id', name: 'Pedido', component: OrderDetails, invisibleInSidebar: true },
  { path: '/discounts', name: 'Descontos', icon: 'pe-7s-cash', component: Discounts },
  { path: '/discount/:discountID', name: '', component: DiscountConditions, invisibleInSidebar: true },
  { path: '/fabrics', name: 'Tecidos', icon: 'pe-7s-albums', component: Fabrics },
  { path: '/fabric-lines', name: 'Faixas de Tecido', icon: 'pe-7s-paint', component: FabricLines },
  { path: '/products', name: 'Produtos sob Encomenda', icon: 'pe-7s-edit', component: Products },
  { path: '/stock-products', name: 'Produtos à Pronta Entrega', icon: 'pe-7s-ticket', component: StockProducts },
  { path: '/corporate', name: 'Corporativo', icon: 'pe-7s-portfolio', component: Corporate },
  { path: '/product/:id', name: 'Produto', component: ProductProfile, invisibleInSidebar: true }
]
export default eneleRoutes



// WEBPACK FOOTER //
// ./src/routes/enele.jsx